import PropTypes from 'prop-types';
import styled from 'styled-components';

import { buildStyledComponent } from 'decisiv-ui-utils';
import { Container } from 'styled-components-reactive-grid';

/* istanbul ignore next */
const styles = ({ theme }) => `
  background-color: ${theme.colors.base.chrome100};
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome100: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'StatusPane',
  styled(Container),
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./components/WizardControllerHeader/StatusPane.js